module.exports = __webpack_public_path__ + "static/media/Polygon-darkGreen.8eae97d4.svg";